import React, { useMemo, useState } from 'react'
import { Col, Form, FormInstance, Input, Row } from 'antd'
import { CommunitySchoolStore } from 'state/setting/communitySchool'
import { myStore } from 'state/store'
import { Photo } from 'types/globalTypes'
import { CommunitySchoolType } from 'types/settings/communityschool'
import UploadDocument from 'components/global/UploadDocument'
import { formValidationOnRequiredFields, validateUrl } from 'helper/utility'
import {
  useAddCommunitySchool,
  useUpdateCommunitySchool,
} from 'api/Settings/ManageCommunities'

interface CommunitySchoolFormProps {
  form: FormInstance
}

const CommunitySchoolForm: React.FC<CommunitySchoolFormProps> = ({ form }) => {
  const {
    setAddCommunitySchoolModal,
    communitySchoolData,
    setCommunitySchoolData,
  }: {
    setAddCommunitySchoolModal: (value: boolean) => void
    communitySchoolData: CommunitySchoolType | undefined
    setCommunitySchoolData: (state: CommunitySchoolType | undefined) => void
  } = CommunitySchoolStore(store => ({
    setAddCommunitySchoolModal: store.setAddCommunitySchoolModal,
    communitySchoolData: store.communitySchoolData,
    setCommunitySchoolData: store.setCommunitySchoolData,
  }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)

  const [error, setError] = useState<string>('')
  const [documentIds, setDocumentIds] = useState<string[]>(
    communitySchoolData ? [communitySchoolData.logoId] : [],
  )
  const [photos] = useState<Photo[]>(
    communitySchoolData ? [communitySchoolData.logo] : [],
  )

  const formSchema = {
    name: communitySchoolData ? communitySchoolData.name : undefined,
    website: communitySchoolData ? communitySchoolData.button.link : undefined,
  }

  const { mutate: adddCommunitySchool } = useAddCommunitySchool()
  const { mutate: updateCommunitySchool } = useUpdateCommunitySchool()

  const onFinish = (values: { name: string; website: string }) => {
    if (documentIds.length === 0) {
      setError('Logo is required')
      return
    }

    const payload = {
      name: values.name,
      logoId: documentIds[0],
      button: {
        text: 'visit website',
        link: values.website,
      },
    }
    setModalBtnLoader(true)

    if (communitySchoolData) {
      updateCommunitySchool(
        {
          id: communitySchoolData._id,
          payload,
        },
        {
          onSuccess: () => {
            setModalBtnLoader(false)
            setAddCommunitySchoolModal(false)
          },
          onError: () => {
            setModalBtnLoader(false)
          },
        },
      )
    } else {
      adddCommunitySchool(payload, {
        onSuccess: () => {
          setModalBtnLoader(false)
          setAddCommunitySchoolModal(false)
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      })
    }

    console.log(payload, 'this is the payload....')
  }

  useMemo(() => {
    if (documentIds.length > 0) {
      setError(undefined)
    }
  }, [documentIds])

  return (
    <Form
      name="community-school-form"
      form={form}
      initialValues={formSchema}
      onFinish={onFinish}
      layout="vertical"
      autoComplete="off"
    >
      <Row className="mt-10px">
        <Col span={24}>
          <label className="input-label required-input">Name</label>
          <Form.Item
            colon={false}
            name="name"
            rules={[{ required: true, message: 'Name is required' }]}
          >
            <Input placeholder="Enter Name" required name="name" />
          </Form.Item>
        </Col>
      </Row>

      <Row className="-mt-10px">
        <Col span={24}>
          <label className="input-label required-input">Website Url</label>
          <Form.Item
            colon={false}
            name="website"
            rules={[
              { required: true, message: 'Name is required' },
              { validator: validateUrl },
            ]}
          >
            <Input placeholder="Enter Website url" required name="url" />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col>
          <label className="custom-field-label required-input">Add Logo</label>
        </Col>
        <Col span={12}>
          <UploadDocument
            documentIds={documentIds}
            setDocumentIds={setDocumentIds}
            multiple={true}
            docType="image/*"
            files={photos}
          />
        </Col>
        {error && (
          <Col className="-mt-20px" span={24}>
            <p className="ant-form-item-explain-error">{error}</p>
          </Col>
        )}
      </Row>
    </Form>
  )
}

export default CommunitySchoolForm
